// Locale for dates and numbers, following the language chosen in the app (not the browser).
// Arabic keeps Western digits so amounts and order numbers stay readable next to Latin text.
const LOCALES = { en: "en-GB", de: "de-DE", ar: "ar-u-nu-latn" };

export const getDateLocale = () => {
  let lang = "";
  try {
    lang = document.documentElement.lang || localStorage.getItem("language") || "";
  } catch (e) {
    lang = "";
  }
  return LOCALES[String(lang).slice(0, 2)] || LOCALES.en;
};
